import { DaymapQuery as e } from "../daymapQuery.js";
var o;
((n) => {
  class a extends e {
    constructor(t) {
      super(
        ["pointsforstudents", t.studentId],
        t,
        `/lms/api/integrations/points/pointsforstudent?studentId=${t.studentId}`,
        null,
        { stale: 1e3 * 60 * 10, enabled: t.enabled }
        // 10 minutes
      );
    }
  }
  n.PointsForStudent = a;
  class i extends e {
    constructor(t) {
      super(
        ["PointLogForStudent", t.studentId],
        t,
        `/lms/api/integrations/points/pointLogForStudent?studentId=${t.studentId}`,
        null,
        { stale: 1e4, enabled: t.enabled }
      );
    }
  }
  n.PointLogForStudent = i;
  class u extends e {
    constructor() {
      super(
        ["PointsSettings"],
        null,
        "/lms/api/points/settings",
        null,
        { stale: 1e3 * 60 * 5 }
      );
    }
  }
  n.GetPointsSettings = u;
  class d extends e {
    constructor() {
      super(
        ["PointsGraphData"],
        null,
        "/lms/api/points/graph",
        null,
        { stale: 1e3 * 60 * 60 }
      );
    }
  }
  n.GetPointsGraphData = d;
})(o || (o = {}));
export {
  o as points
};
//# sourceMappingURL=index.js.map
